import { Component } from "react"
import PropTypes from "prop-types"
import Feedback from "partners/components/review/feedback"
import sortBy from "lodash/sortBy"
import last from "lodash/last"

import * as $ from "jquery"

export default class FeedbackContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      feedbackItems: this.props.feedbackItems,
      isShowing: false,
      displayAll: false,
    }
    this.showFeedbacks = this.showFeedbacks.bind(this)
    this.showAllFeedbacks = this.showAllFeedbacks.bind(this)
    this.closeFeedbacks = this.closeFeedbacks.bind(this)
    this.hideAllFeedbackFormsOnClickOff = this.hideAllFeedbackFormsOnClickOff.bind(
      this
    )
    this.postFeedback = this.postFeedback.bind(this)
    this.onFeedbackUpdated = this.props.onFeedbackUpdated
  }

  componentDidMount() {
    this.hideListener = window.addEventListener(
      "hideFeedbackContainers",
      () => {
        this.setState({ isShowing: false, displayAll: false })
      }
    )
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ feedbackItems: nextProps.feedbackItems })
  }

  componentWillUnmount() {
    window.removeEventListener("hideFeedbackContainers", this.hideListener)
  }

  hideAllFeedbackFormsOnClickOff(event) {
    let hideForms = true

    $.each($(event.target).parents().addBack(), function (i, p) {
      if ($(p).attr("data-click-behaviour")) {
        hideForms = false
        return false
      }
    })

    if (hideForms) {
      $("body").off("click", this.hideAllFeedbackFormsOnClickOff)
      this.setState({ displayAll: false, isShowing: false })
    }
  }

  showFeedbacks() {
    this.setState({ isShowing: true })
  }

  showAllFeedbacks() {
    this.setState({ displayAll: true, isShowing: true })
    $("body").on("click", this.hideAllFeedbackFormsOnClickOff)
  }

  closeFeedbacks() {
    if (!this.state.displayAll) this.setState({ isShowing: false })
  }

  displayLastFeedback() {
    if (!this.state.isShowing || this.state.feedbackItems.length == 0)
      return null

    const lastItem = last(
      sortBy(this.state.feedbackItems, item => {
        return item.time
      })
    )
    return (
      <div className="feedback-content" data-click-behaviour="keep-open">
        <Feedback
          key={`feedback-${lastItem.time}`}
          values={lastItem}
          pathObjs={this.props.pathObjs}
          preview
        />
      </div>
    )
  }

  displayAll() {
    if (!this.state.isShowing) return null

    const allItems = this.state.feedbackItems.map((item, index) => {
      return (
        <Feedback
          key={`feedback-${item.time}`}
          values={item}
          pathObjs={this.props.pathObjs}
          index={index}
          service={this.props.service}
          onFeedbackUpdated={this.props.onFeedbackUpdated}
        />
      )
    })
    return (
      <div className="feedback-content" data-click-behaviour="keep-open">
        {allItems}
        {this.newFeedbackForm()}
      </div>
    )
  }

  postFeedback(event) {
    event.preventDefault()

    const _target = $(event.target).closest("form").find("#comment")
    let _feedback = _target.val()
    _feedback = _feedback.replace(/(\r\n|\n|\r)/gm, " ")

    if (/\S/.test(_feedback)) {
      const request = $.ajax({
        type: "POST",
        url: `/services/${this.props.service.slug}/feedbacks`,
        data: JSON.stringify({
          feedback: _feedback,
          feedback_path: this.props.pathObjs,
          authenticity_token: window.App.authenticityToken,
        }),
        dataType: "json",
        contentType: "application/json",
      })

      request.done(
        function (response) {
          this.onFeedbackUpdated(response)
          _target.val("")
        }.bind(this)
      )
    } else {
      window.alert("You should write something first!")
    }
  }

  newFeedbackForm() {
    return (
      <form className="form" data-click-behaviour="keep-open">
        <div className="field" data-click-behaviour="keep-open">
          <div className="label" data-click-behaviour="keep-open">
            Add a note on <strong>{this.props.fieldName}</strong>:
          </div>
          <div className="input" data-click-behaviour="keep-open">
            <textarea
              id="comment"
              name="comment"
              required="required"
              rows="3"
              autoFocus
              data-click-behaviour="keep-open"
            />
          </div>
          <p className="note" data-click-behaviour="keep-open" />
        </div>
        <div className="action" data-click-behaviour="keep-open">
          <button
            className="button-tertiary"
            data-click-behaviour="keep-open"
            data-disable-with="Saving…"
            onClick={this.postFeedback}
          >
            Post
          </button>
        </div>
      </form>
    )
  }

  renderBubble() {
    return (
      <div data-click-behaviour="keep-open">
        <span
          className="feedback-icon"
          data-click-behaviour="keep-open"
          onClick={this.showAllFeedbacks}
          title="Feedback"
        />
        <div data-click-behaviour="keep-open">
          {this.state.displayAll
            ? this.displayAll()
            : this.displayLastFeedback()}
        </div>
      </div>
    )
  }

  renderInactive() {
    if (this.state.displayAll) return this.renderBubble()

    return (
      <span
        className="feedback-icon inactive"
        data-click-behaviour="keep-open"
        onClick={this.showAllFeedbacks}
        title="Feedback"
      />
    )
  }

  render() {
    return (
      <div
        className="feedback-container"
        data-click-behaviour="keep-open"
        onMouseOver={this.showFeedbacks}
        onMouseOut={this.closeFeedbacks}
        onClick={this.showAllFeedbacks}
      >
        {this.state.feedbackItems.length > 0
          ? this.renderBubble()
          : this.renderInactive()}
      </div>
    )
  }
}

FeedbackContainer.propTypes = {
  feedbackItems: PropTypes.array,
  fieldName: PropTypes.string,
  service: PropTypes.object,
  pathObjs: PropTypes.array,
  onFeedbackUpdated: PropTypes.func,
}

FeedbackContainer.defaultProps = {
  feedbackItems: [],
}
